<template>
  <v-app :style="{ backgroundColor: $vuetify.theme.themes.dark.background }">
      <router-view/>
  </v-app>
</template>

<script>
export default {
  name: 'App',

};
</script>
<style>

#app {
    height: 100%;
    touch-action: manipulation;
    

}
</style>